import React from "react";
import { MapPin, Calendar, Users } from "lucide-react";
import { Mandala } from "@/components/decor/Motifs";

export default function VenueInfo() {
    return (
        <section
            id="venue"
            className="relative px-6 md:px-12 lg:px-24 py-20 md:py-24 bg-inkbrown-900 overflow-hidden"
            data-testid="venue-section"
        >
            <Mandala
                stroke="#D4AF37"
                className="absolute -top-40 -left-40 w-[500px] h-[500px] opacity-10 animate-spin-slower"
            />
            <Mandala
                stroke="#FF9933"
                className="absolute -bottom-40 -right-40 w-[520px] h-[520px] opacity-10 animate-spin-slow"
            />
            <div className="relative mx-auto max-w-5xl grid grid-cols-1 md:grid-cols-3 gap-6">
                <InfoCard
                    icon={Calendar}
                    label="Date & Time"
                    value="17 July 2026"
                    sub="10:00 AM — 4:00 PM"
                    testid="venue-info-date"
                />
                <InfoCard
                    icon={MapPin}
                    label="Venue"
                    value="Nitai Gaur Temple"
                    sub="Sobujbag, Sreemangal"
                    testid="venue-info-location"
                />
                <InfoCard
                    icon={Users}
                    label="Organised By"
                    value="IYS"
                    sub="Sreemangal"
                    testid="venue-info-organiser"
                />
            </div>
        </section>
    );
}

function InfoCard({ icon: Icon, label, value, sub, testid }) {
    return (
        <div
            className="glass-dark rounded-3xl p-8 text-center hover:shadow-glow transition-all"
            data-testid={testid}
        >
            <div className="mx-auto w-14 h-14 rounded-2xl bg-saffron-500/15 border border-vgold-400/30 flex items-center justify-center">
                <Icon className="w-6 h-6 text-vgold-300" />
            </div>
            <p className="mt-6 font-body text-[10px] uppercase tracking-[0.3em] text-vgold-300/80">
                {label}
            </p>
            <p className="mt-2 font-heading text-2xl md:text-3xl text-cream-50">
                {value}
            </p>
            <p className="mt-1 font-body text-sm text-cream-50/70">{sub}</p>
        </div>
    );
}
